import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import { tannerGray } from '../colors';

type MuiFormLabel = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiFormLabel'];
  defaultProps?: ComponentsProps['MuiFormLabel'];
  variants?: ComponentsVariants['MuiFormLabel'];
};

export const MuiFormLabel: MuiFormLabel = {
  styleOverrides: {
    root: {
      color: '#000',
      fontSize: 14,
      fontWeight: 800,
      lineHeight: '130%',
      '&.Mui-disabled': {
        color: tannerGray['400'],
      },
    },
  },
};
